import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UserStoreService } from '@core/services/user-store/user-store.service';
import { filter, map, Observable, of, take } from 'rxjs';
import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root'
})
export class DefaultRouteRedirectGuard implements CanActivate {
  private router = inject(Router);
  private userStore = inject(UserStoreService);
  private keycloak = inject(Keycloak);

  canActivate(): Observable<UrlTree> {
    // keep compatibility with hash routing and redirect to corresponding route without hashing
    if (window.location.hash.startsWith('#/')) {
      this.redirectToRoute(window.location.hash.slice(1));
      return of(null); // Indicate that navigation should not proceed
    }

    // if user is not already authenticated, redirect to login page
    // otherwise they will get stuck on a blank page, as the guard will not allow navigation
    // to a route that has the AuthSsoGuard, which triggers a login step if the user is not authenticated
    if (!this.keycloak.authenticated) {
      this.keycloak.login();
      return of(null);
    }

    return this.userStore.isAuthenticated$.pipe(
      filter((isAuthenticated) => !!isAuthenticated),
      take(1),
      map(() => this.router.createUrlTree(['overview']))
    );
  }

  private redirectToRoute(route: string): void {
    window.location.href = route;
  }
}
